export const GET_SEARCH = 'search/get';
export const GET_SEARCH_SUCCESS = 'search/get/success';
